<template>
	<div class="page-dashboard">
		<div class="container-fluid flex-center">
			<h2 class="text-primary mb-4">{{ $t(title) }}</h2>
			<div class="table-menu flex-center">
				<div class="ml-a">
                    <md-icon class="icon-1-feedback mr-1">sentiment_very_dissatisfied</md-icon>
					<span>{{statistics && statistics.total_level_1 ? statistics.total_level_1 : '0'}}</span>
                    <span class="vl"></span>
                    <md-icon class="icon-2-feedback mr-1">sentiment_dissatisfied</md-icon>
					<span>{{statistics && statistics.total_level_2 ? statistics.total_level_2 : '0'}}</span>
                    <span class="vl"></span>
                    <md-icon class="icon-3-feedback mr-1">sentiment_satisfied</md-icon>
					<span>{{statistics && statistics.total_level_3 ? statistics.total_level_3 : '0'}}</span>
                    <span class="vl"></span>
                    <md-icon class="icon-4-feedback mr-1">sentiment_very_satisfied</md-icon>
					<span>{{statistics && statistics.total_level_4 ? statistics.total_level_4 : '0'}}</span>
				</div>
			</div>
		</div>
        <!-- Main List -->
		<div class="text-center" v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
        <div v-if="items.length > 0" class="rundowns row mr-2 ml-1 feedback-list">
            <div
                class="col-lg-12 col-md-12 mb-3"
                v-for="item in items"
                :key="item.id">
                <feedback-list
                    :item="item"
                />
            </div>
        </div>
		<div v-if="items.length === 0 && !isFetching">
			<div class="card col-lg-12 col-md-12 mb-3 pb-2 text-center">
				<div class="card-body mt-2">
						<span>
							{{ $t('No Feedback Available') }}
						</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FeedbackList from '@/components/FeedbackList.vue';
// import Pagination from '@/components/Pagination.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import feedbacksApi from '@/api/feedbacks';

export default {
	name: 'Displays',
	components: {
		// Pagination,
		FeedbackList,
	},
	data() {
		return {
			page: 1,
			limit: 25,
			orderBy: 'id',
			sortBy: 'asc',
			keyword: '',
			isAll: false,
			items: [],
			selected: null,
			statistics: [],
			// totalPages: 2,
			totalItems: 0,
			lastPage: 1,
			title: this.$t('Manage Feedbacks'),
			isFetching: false,
		};
	},
	methods: {
		...mapActions({
		}),
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) {
				this.page = page;
			}
			const params = this.fetchParams;
			const callback = (response) => {
				const items = response.data;
				if (items.length < this.limit) {
					this.isAll = true;
				}
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			feedbacksApi.getList(params, callback, errorCallback);
		},
		fetchStatistic() {
			const callback = (response) => {
				const items = response.data;
				this.statistics = items;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
			};
			feedbacksApi.getStatistic(callback, errorCallback);
		},
		onPageSelected(page) {
			this.fetch(true, page);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		fetchParams() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
			};
			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}
			return params;
		},
		totalPages() {
			const total = Math.ceil(this.totalItems / this.limit);
			return total;
		},
	},
	created() {
		this.fetch();
		this.fetchStatistic();
	},
};
</script>
